import { triggerFloatingLink } from 'lib-knowledge-document-structure/index';
import {
  focusEditor,
  isType,
  someNode,
} from 'lib-knowledge-document-structure/plate/common';
import { useMyEditorRef } from 'lib-knowledge-document-structure/plateHooks';
import {
  ELEMENT_ANCHOR_LINK,
  ELEMENT_INTERLINK,
  ELEMENT_LINK,
} from 'lib-knowledge-document-structure/plateTypes';

import { ToolbarButton } from '../toolbar';

const LinkToolbarButton = (): JSX.Element => {
  const editor = useMyEditorRef();
  const isLink =
    !!editor?.selection &&
    someNode(editor, {
      match: (node) =>
        isType(editor, node, [
          ELEMENT_INTERLINK,
          ELEMENT_LINK,
          ELEMENT_ANCHOR_LINK,
        ]),
    });

  return (
    <ToolbarButton
      isActive={isLink}
      icon="link"
      onMouseDown={async (ev) => {
        if (!editor) return;
        ev.preventDefault();
        ev.stopPropagation();

        focusEditor(editor, editor.selection ?? editor.prevSelection!);
        setTimeout(() => {
          triggerFloatingLink(editor, { focused: true });
        }, 0);
      }}
    />
  );
};

export default LinkToolbarButton;
